import createReactComponent from '../createReactComponent';
export default createReactComponent('shuffle', 'Shuffle', [["path",{"d":"M15.5 4h4.412v4.444M4 20 19 5m1 10.5V20h-4.5M14 14l5.294 5.333M4 4l6 6","key":"svg-0"}]]);